import { useCallback } from 'react'
import styled, { css } from 'styled-components'
import { useInterface } from '../../contexts/InterfaceProvider'
import { Breakpoint } from '../../styles/functions'
import ButtonInline from '../button/ButtonInline'

interface P {
  setIsOpen,
  showFilter?: boolean
}
const CollectionMode: React.FC<P> = ({ 
  setIsOpen,
  showFilter=false,
  // ...props
}: P) => {
  const {setCollectionMode, collectionMode,} = useInterface();

  const onClick = (newLayout) => useCallback(() => {
    setCollectionMode(newLayout);
  }, [setCollectionMode])


  return (
    <Controls>
      <Button 
        onClick={onClick("OVERVIEW")}
        disabled={collectionMode == 'OVERVIEW'} 
      >Overview</Button>
      &nbsp;/&nbsp;
      <Button 
        onClick={onClick("GRID")}
        disabled={collectionMode == 'GRID'} 
      >Grid</Button>

      { 
        showFilter && 
        <FilterButton
          onClick={() => setIsOpen(true)}
        >
          Filter +
        </FilterButton>
      }
    </Controls>
  )
}

const Controls = styled.div`
  margin-bottom: var(--spacing-24);
`

const Button = styled(ButtonInline)`
  display: inline-flex;
  vertical-align: baseline;
`

const FilterButton = styled(Button)`
  margin-left: 16px;

  ${Breakpoint('mobile', 'min')} {
    display: none;
  }
`

export default CollectionMode